import { tzAxios } from 'api/axios';
import type { AcceptInvitationResponse, InvitationResponse } from './types';

export const getInvitation = (invitationId: string) =>
  tzAxios.get<InvitationResponse>(`/ticket-zone/invitation/${invitationId}`).then((r) => r.data);

export const acceptInvitation = (invitationId: string) =>
  tzAxios
    .post<AcceptInvitationResponse>(`/ticket-zone/invitation/${invitationId}/accept`)
    .then((r) => r.data);
